import { createContext, ReactNode, useContext, useState } from 'react'

export interface ModalData {
  contents?: {
    title?: string
    desc?: string
    children?: ReactNode
  }
  styles?: {
    desc?: {
      fontSize?: number
      textAlign?: 'left' | 'center' | 'right'
      bgColor?: string
    }
  }
  buttons?: {
    cancel?: { text: string; func?: () => void; close?: boolean }
    submit?: { text: string; func?: () => void; close?: boolean }
  }
}

type ModalContextType = {
  isOpen: boolean
  openModal: (data: ModalData) => void
  closeModal: () => void
  modalData: ModalData
}

const ModalContext = createContext<ModalContextType>({
  isOpen: false,
  openModal: () => {},
  closeModal: () => {},
  modalData: {},
})

export const ModalContextProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [modalData, setModalData] = useState<ModalData>({})

  const openModal = (data: ModalData) => {
    setIsOpen(true)
    setModalData(data)
  }

  const closeModal = () => {
    setIsOpen(false)
    setModalData({})
  }

  return (
    <ModalContext.Provider value={{ isOpen, openModal, closeModal, modalData }}>
      {children}
    </ModalContext.Provider>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export function useModal() {
  return useContext(ModalContext)
}
